import React, { useContext } from 'react';
import { AirDropContext } from '../../../utils/AirDropProvider';
import { ROUTES } from '../../constants/routes.js';
import Link from '../Link/Link';
import { event } from '../../../services';
import { USER_INTERACTION_NAME } from '../../constants/googleAnalytics4Event';
import useFeatures from '../../hooks/useFeatures';
import useTranslation from '../../hooks/useTranslation';

interface CreateAccountBlurbProps {
  gaEventCategory: string
}
function CreateAccountBlurb({
  gaEventCategory,
} : CreateAccountBlurbProps) {
  const config: any = useContext(AirDropContext);
  const { isPDotCom } = useFeatures();
  const { translateText } = useTranslation();
  const { signupConfig, chooseAccountType } = config;
  const { url } = signupConfig;
  const signupConfigUrl = url;

  const createAccountType = signupConfig?.type;

  let createAccountButtonLabel = 'Create account';
  let createAccountHeading = 'New to Pearson?';
  if (createAccountType === 'register') {
    createAccountButtonLabel = 'Register';
    createAccountHeading = 'Need to register?';
  } else if (createAccountType === 'createAccount') {
    createAccountButtonLabel = isPDotCom ? 'Create an account' : 'Create account';
  }

  const eventGotoCreateAccount = () => {
    event(USER_INTERACTION_NAME, gaEventCategory, 'Link', `${gaEventCategory} Create Account button`);
  };

  const getCreateAccountLink = () => {
    if (chooseAccountType) {
      return ROUTES.CHOOSE_ACCOUNT_TYPE_INTERNAL;
    }

    if (signupConfigUrl) {
      return signupConfigUrl;
    }

    return ROUTES.CREATE_ACCOUNT_INTERNAL;
  };

  return (
    <div className="subheading">
      <span>
        {translateText(createAccountHeading)}
        &nbsp;&nbsp;&nbsp;
      </span>
      <Link to={getCreateAccountLink()} onClick={() => eventGotoCreateAccount()}>
        {translateText(createAccountButtonLabel)}
      </Link>
    </div>
  );
}

export default CreateAccountBlurb;
